"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecificPriceEditor = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Field_1 = require("../../../Form/Field");
const SpecificPriceEditor = (props) => {
    const { field } = props;
    return (react_1.default.createElement(Field_1.FormField, { autoComplete: 'off', label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/AdminPayment:specificPrice', defaultMessage: 'Specific price' }), name: 'specific-price', error: field.error, value: field.input, onChange: field.onEvent, disabled: field.disabled, hidden: field.hidden, modificators: field.modifiers, addon: 'CHF' }));
};
exports.SpecificPriceEditor = SpecificPriceEditor;
//# sourceMappingURL=specificPrice.js.map